var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2381_520)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.5,
    fill: "#6AC7BD",
    stroke: "#6AC7BD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7832C5 11.0293 5.08659 11.2389 5.25977 11.4121C5.43294 11.5807 5.6403 11.665 5.88184 11.665H9.9082V15.6914C9.9082 15.9284 9.99251 16.1335 10.1611 16.3066C10.3298 16.4798 10.5371 16.5664 10.7832 16.5664C11.0247 16.5664 11.2321 16.4798 11.4053 16.3066C11.5785 16.1335 11.665 15.9284 11.665 15.6914V11.665H15.6914C15.9284 11.665 16.1335 11.5807 16.3066 11.4121C16.4798 11.2389 16.5664 11.0293 16.5664 10.7832C16.5664 10.5417 16.4798 10.3343 16.3066 10.1611C16.1335 9.98796 15.9284 9.90137 15.6914 9.90137H11.665V5.88184C11.665 5.6403 11.5785 5.43294 11.4053 5.25977C11.2321 5.08659 11.0247 5 10.7832 5C10.5371 5 10.3298 5.08659 10.1611 5.25977C9.99251 5.43294 9.9082 5.6403 9.9082 5.88184V9.90137H5.88184C5.6403 9.90137 5.43294 9.98796 5.25977 10.1611C5.08659 10.3343 5 10.5417 5 10.7832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2381_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/PlusRounded.3526c20c6f50e35b927d9cee7ea7345b.svg";
export { ForwardRef as ReactComponent };